<script setup>
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    default: 20,
  },
  height: {
    type: Number,
  },
  svg: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: '',
  },
  additionalClasses: {
    type: Object,
    default: () => {},
  },
});

const calculatedHeight = computed(() => props.height || props.width);
const calculatedColor = computed(() => props.color);
const renderAsSvg = computed(() => props.svg || !!props.color);
</script>

<template>
  <img
    v-if="!renderAsSvg"
    class="icon"
    :class="additionalClasses"
    :src="require(`@/assets/svg-icons/${icon}.svg`)"
    :width="width"
    :height="calculatedHeight"
    alt=""
  />
  <InlineSvg
    v-if="renderAsSvg"
    class="svg-icon"
    :class="additionalClasses"
    :src="require(`@/assets/svg-icons/${icon}.svg`)"
    :width="width"
    :height="calculatedHeight"
  />
</template>

<style lang="scss" scoped>
.svg-icon {
  :deep(path) {
    fill: v-bind(calculatedColor);
  }
}
</style>
